import Vue from 'vue'
import VueRouter from 'vue-router'

// 路由懒加载
const Login = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../pages/Login.vue')
const Register = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../pages/register.vue')
const Home = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../pages/Home.vue')
const Welcome = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../pages/Welcome.vue')
const screen = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../pages/screen.vue')

const projectInfo = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/projectInfo.vue')
const thirdPay = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/thirdPay.vue')
const entry = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/entry.vue')
const userfieldset = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/userfieldset.vue')
const doc = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/doc.vue')
const tabbar = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/tabbar.vue')
const pages = () => import(/* webpackChunkName: "setting" */ '../pages/mall/setting/pages.vue')

const mechanism = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/mechanism.vue')
const userLevel = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/userLevel.vue')
const userAccount = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/userAccount.vue')
const rewardInvite = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/rewardInvite.vue')
const rewardOrder = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/rewardOrder.vue')
const financeAccount = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/financeAccount.vue')
const rewardPlat = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/rewardPlat.vue')
const mall = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/mall.vue')
const sendRule = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/sendRule.vue')
const signin = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/signin.vue')
const videoSign = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/videoSign.vue')
const article = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/article.vue')
const articlecate = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/articlecate.vue')
const card = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/card.vue')
const catalogue = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/catalogue.vue')
const freeQueue = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/freeQueue.vue')
const freeQueueTwo = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/freeQueueTwo.vue')
const limitWithdraw = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/limitWithdraw.vue')
const advert = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/advert.vue')
const live = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/live.vue')
const bonus = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/bonus.vue')
const ssg = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/ssg.vue')
const freight = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/freight.vue')
const tsg = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/tsg.vue')
const realname = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/realname.vue')
const alone = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/alone.vue')
const qht = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/qht.vue')
const trade = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/trade.vue')
const tuan = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/tuan.vue')
const pk = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/pk.vue')
const subaccount = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/subaccount.vue')
const pvbv = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/pvbv.vue')

const giftbag = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/giftbag.vue')

const ancestralhall = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/ancestralhall.vue')

const rewardProfile = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/rewardProfile.vue')

const addon = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/addon.vue')
const wodian = () => import(/* webpackChunkName: "finance" */ '../pages/mall/mechanism/wodian.vue')


const admin = () => import(/* webpackChunkName: "auth" */ '../pages/mall/auth/admin.vue')
const role = () => import(/* webpackChunkName: "auth" */ '../pages/mall/auth/role.vue')
const log = () => import(/* webpackChunkName: "auth" */ '../pages/mall/auth/log.vue')

const user = () => import(/* webpackChunkName: "user" */ '../pages/user/user.vue')
const agent = () => import(/* webpackChunkName: "user" */ '../pages/user/agent.vue')
const store = () => import(/* webpackChunkName: "user" */ '../pages/user/store.vue')
const crowner = () => import(/* webpackChunkName: "user" */ '../pages/user/crowner.vue')
const partner = () => import(/* webpackChunkName: "user" */ '../pages/user/partner.vue')


const good = () => import(/* webpackChunkName: "good" */ '../pages/good/good.vue')
const cate = () => import(/* webpackChunkName: "good" */ '../pages/good/cate.vue')
const audit = () => import(/* webpackChunkName: "good" */ '../pages/good/audit.vue')
const price = () => import(/* webpackChunkName: "good" */ '../pages/good/price.vue')
const stock = () => import(/* webpackChunkName: "good" */ '../pages/good/stock.vue')
const activity = () => import(/* webpackChunkName: "good" */ '../pages/good/activity.vue')
const coupon = () => import(/* webpackChunkName: "good" */ '../pages/good/coupon.vue')

const supplysetting = () => import(/* webpackChunkName: "good" */ '../pages/good/supplysetting.vue')

const order = () => import(/* webpackChunkName: "order" */ '../pages/order/order.vue')
const after = () => import(/* webpackChunkName: "order" */ '../pages/order/after.vue')
const comment = () => import(/* webpackChunkName: "order" */ '../pages/order/comment.vue')

const scanorder = () => import(/* webpackChunkName: "order" */ '../pages/order/scanorder.vue')
const yinfaorder = () => import(/* webpackChunkName: "order" */ '../pages/order/yinfaorder.vue')

const movie = () => import(/* webpackChunkName: "finance" */ '../pages/order/movie.vue')

const virtual = () => import(/* webpackChunkName: "finance" */ '../pages/virtual/virtual.vue')

const cps = () => import(/* webpackChunkName: "user" */ '../pages/mall/mechanism/cps.vue')

const life = () => import(/* webpackChunkName: "finance" */ '../pages/life/life.vue')
const flow = () => import(/* webpackChunkName: "finance" */ '../pages/finance/flow.vue')
const withdraw = () => import(/* webpackChunkName: "finance" */ '../pages/finance/withdraw.vue')
const statistics = () => import(/* webpackChunkName: "finance" */ '../pages/finance/statistics.vue')
const commission = () => import(/* webpackChunkName: "finance" */ '../pages/finance/commission.vue')

const financeaccountflow = () => import(/* webpackChunkName: "finance" */ '../pages/finance/financeaccount.vue')
const cashlog = () => import(/* webpackChunkName: "finance" */ '../pages/finance/cashlog.vue')
const profit = () => import(/* webpackChunkName: "finance" */ '../pages/report/profit.vue')
const overview = () => import(/* webpackChunkName: "finance" */ '../pages/report/overview.vue')

const survey = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/survey.vue')
const grossProfit = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/grossProfit.vue')
const financeDay = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/financeDay.vue')
const goodsSell = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/goodsSell.vue')
const sourceFinance = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/sourceFinance.vue')
const userPerformance = () => import(/* webpackChunkName: "finance" */ '../pages/statistics/userPerformance.vue')

/** 商家页面 */
const storehome = () => import(/* webpackChunkName: "store" */ '../store/home.vue')
const storewelcome = () => import(/* webpackChunkName: "store" */ '../store/welcome.vue')
const storecate = () => import(/* webpackChunkName: "store" */ '../store/good/cate.vue')
const storegood = () => import(/* webpackChunkName: "store" */ '../store/good/good.vue')
const storeorder = () => import(/* webpackChunkName: "store" */ '../store/order/order.vue')
const storeafter = () => import(/* webpackChunkName: "store" */ '../store/order/after.vue')
const storeflow = () => import(/* webpackChunkName: "store" */ '../store/finance/flow.vue')
const storecoupon = () => import(/* webpackChunkName: "store" */ '../store/mechanism/coupon.vue')
const storeactivity = () => import(/* webpackChunkName: "store" */ '../store/mechanism/activity.vue')
const storeprint = () => import(/* webpackChunkName: "store" */ '../store/set/print.vue')
const storeoperate = () => import(/* webpackChunkName: "store" */ '../store/set/operate.vue')
const storead = () => import(/* webpackChunkName: "store" */ '../store/set/ad.vue')

const increaccount = () => import(/* webpackChunkName: "mechanism" */ '../pages/mall/mechanism/increaccount.vue')
const reduce = () => import(/* webpackChunkName: "mechanism" */ '../pages/good/reduce.vue')

Vue.use(VueRouter)

// 加载插件中定义的router
const ADDON_ROUTE = []
const files = require.context('~/addon', true, /index\.js$/);
files.keys().forEach((key) =>
    ADDON_ROUTE.push(...files(key).default)
);

const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    { path: '/screen', component: screen},
    {
        path: '/home',
        component: Home,
        redirect: '/Welcome',
        // redirect: '/projectInfo',
        children: [
            { path: '/home', component: Welcome },
            // { path: '/home', component: projectInfo },
            { path: '/projectInfo', component: projectInfo },
            { path: '/thirdPay', component: thirdPay },
            { path: '/entry', component: entry },
            { path: '/userfieldset', component: userfieldset },
            { path: '/doc', component: doc },
            { path: '/tabbar', component: tabbar },
            { path: '/pages', component: pages },

            { path: '/mechanism', component: mechanism },
            { path: '/userLevel', component: userLevel },
            { path: '/userAccount', component: userAccount },
            { path: '/rewardInvite', component: rewardInvite },
            { path: '/rewardOrder', component: rewardOrder },
            { path: '/financeAccount', component: financeAccount },
            { path: '/rewardPlat', component: rewardPlat },
            { path: '/mall', component: mall },
            { path: '/sendRule', component: sendRule },
            { path: '/signin', component: signin },
            { path: '/videoSign', component: videoSign },
            { path: '/article', component: article },
            { path: '/articlecate', component: articlecate },
            { path: '/card', component: card },
            { path: '/catalogue', component: catalogue },
            { path: '/freeQueue', component: freeQueue },
            { path: '/freeQueueTwo', component: freeQueueTwo },
            { path: '/limitWithdraw', component: limitWithdraw },
            { path: '/advert', component: advert },
            { path: '/live', component: live },
            { path: '/bonus', component: bonus },
            { path: '/ssg', component: ssg },
            { path: '/freight', component: freight },
            { path: '/tsg', component: tsg },
            { path: '/realname', component: realname },
            { path: '/alone', component: alone },
            { path: '/qht', component: qht },
            { path: '/trade', component: trade },
            { path: '/tuan', component: tuan },
            { path: '/pk', component: pk },
            { path: '/subaccount', component: subaccount },
            { path: '/addon', component: addon },
            { path: '/giftbag', component: giftbag },
            { path: '/pvbv', component: pvbv },
            { path: '/ancestralhall', component: ancestralhall },
            { path: '/rewardProfile', component: rewardProfile },

            { path: '/admin', component: admin },
            { path: '/role', component: role },
            { path: '/log', component: log },

            { path: '/user', component: user },
            { path: '/agent', component: agent },
            { path: '/store', component: store },
            { path: '/crowner', component: crowner },
            { path: '/partner', component: partner },

            { path: '/good', component: good },
            { path: '/cate', component: cate },
            { path: '/audit', component: audit },
            { path: '/price', component: price },
            { path: '/stock', component: stock },
            { path: '/activity', component: activity },
            { path: '/coupon', component: coupon },
            { path: '/supplysetting', component: supplysetting },

            { path: '/order', component: order },
            { path: '/after', component: after },
            { path: '/comment', component: comment },
            { path: '/scanorder', component: scanorder },
            { path: '/yinfaorder', component: yinfaorder },
            { path: '/movie', component: movie },
            { path: '/virtual', component: virtual },
            { path: '/life', component: life },
            { path: '/cps', component: cps },
            // { path: '/wodian', component: wodian },
            { path: '/increaccount', component: increaccount },
            { path: '/reduce', component: reduce },

            { path: '/flow', component: flow },
            { path: '/financeaccountflow', component: financeaccountflow},
            { path: '/cashlog', component: cashlog},
            { path: '/withdraw', component: withdraw },
            { path: '/statistics', component: statistics },
            { path: '/commission', component: commission },

            { path: '/profit', component: profit },
            { path: '/overview', component: overview },

            { path: '/survey', component: survey },
            { path: '/grossProfit', component: grossProfit },
            { path: '/financeDay', component: financeDay },
            { path: '/goodsSell', component: goodsSell },
            { path: '/sourceFinance', component: sourceFinance },
            { path: '/userPerformance', component: userPerformance },
            

            { path: '/salesroom', component: () => import(/* webpackChunkName: "order" */ '../pages/order/salesroom.vue') },

            ...ADDON_ROUTE,
        ]
    },
    {
        path: '/storehome', 
        component: storehome,
        redirect: '/storewelcome',
        // redirect: '/projectInfo',
        children: [
            { path: '/storehome', component: storewelcome },
            { path: '/storecate', component: storecate },
            { path: '/storegood', component: storegood },
            { path: '/storeorder', component: storeorder },
            { path: '/storeafter', component: storeafter },
            { path: '/storeflow', component: storeflow },
            { path: '/storecoupon', component: storecoupon },
            { path: '/storeactivity', component: storeactivity },
            { path: '/storeprint', component: storeprint },
            { path: '/storeoperate', component: storeoperate },
            { path: '/storead', component: storead },
        ]
    },
    {
        path: '/404',
        component: () => import('../pages/404.vue')
    },
    {
        path: '*',
        redirect: '/404'
    }
]
console.log('routes', routes)
const router = new VueRouter({
    routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    console.log('router.beforeEach to', to)
    var token = window.localStorage.getItem('token');
    var activePath = window.localStorage.getItem('activePath');
    if (to.path === '/login') {
        console.log('router.beforeEach', token, to.query, activePath)
        if(token && (!to.query.ticket && !to.query.signature)){
            return next(activePath ? activePath : '/home')
        }
        return next()
    }
    if (to.path === '/register') {
        return next()
    }
    if (!token) {
        return next('/login')
    }
    to.meta.keepAlive = true;
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js